import { render, staticRenderFns } from "./ReporteMilConfigCapitulo.vue?vue&type=template&id=1792fa78&"
import script from "./ReporteMilConfigCapitulo.vue?vue&type=script&lang=js&"
export * from "./ReporteMilConfigCapitulo.vue?vue&type=script&lang=js&"
import style0 from "./ReporteMilConfigCapitulo.vue?vue&type=style&index=0&id=1792fa78&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports